import PropTypes from 'prop-types';
import React from 'react';

const VehicleBannerOverlay = ({ icon, content }) => {
    const iconClasses = ['vehicleBanner-filter-icon'];
    if (icon) {
        iconClasses.push(icon);
    }

    return (
        <div className="vehicleBanner--filter">
            <div className="vehicleBanner--filter__content">
                <icon className={iconClasses.join(' ')} />
                {content}
            </div>
        </div>
    );
};

VehicleBannerOverlay.defaultProps = {
    icon: '',
};

VehicleBannerOverlay.propTypes = {
    icon: PropTypes.string,
    content: PropTypes.string.isRequired,
};

VehicleBannerOverlay.displayName = 'VehicleBannerOverlay';

export default VehicleBannerOverlay;



// WEBPACK FOOTER //
// ./src/Vehicle/components/VehicleBannerWithCarrousel/VehicleBanner/VehicleBannerOverlay/VehicleBannerOverlay.jsx